import { z } from 'zod';

export const getQrCodeContentResDto = z.object({
  qrCodeContent: z.string().max(2048),
});

export type GetQrCodeContentResDto = z.infer<typeof getQrCodeContentResDto>;
